// ─── PreviewOnPhoneButton ─────────────────────────────────────
// Owner-facing button (used in LayoutVersionPanel inside Event Setup).
// Opens the shared PhonePreviewModal — same modal used by the Studio
// toolbar (Phase 1.7).

import React, { useState } from 'react';
import { QrCode } from 'lucide-react';
import PhonePreviewModal from './PhonePreviewModal';

export default function PreviewOnPhoneButton({
  slug,
  layoutVersion,
  layoutMode,
  updatedAt,
  isPublished,
  previewToken,
  adminDarkMode = false,
}) {
  const [open, setOpen] = useState(false);
  if (!slug) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors whitespace-nowrap ${
          adminDarkMode
            ? 'border-gray-600 text-gray-300 hover:bg-gray-700'
            : 'border-gray-300 text-gray-700 hover:bg-gray-100'
        }`}
        data-testid="preview-on-phone-btn"
      >
        <QrCode className="w-3.5 h-3.5" />
        Preview on phone
      </button>

      {open && (
        <PhonePreviewModal
          slug={slug}
          layoutVersion={layoutVersion}
          layoutMode={layoutMode}
          updatedAt={updatedAt}
          isPublished={isPublished}
          previewToken={previewToken}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
